import React from 'react';
import PropTypes from 'prop-types';
import { List, ListItem } from 'chaoskit/src/components';

import { Data } from '../../components';

const GradientList = ({ items }) => (
  <List className="shared__gradientList">
    {items.map(item => (
      <ListItem
        key={item.blurb}
        className={
          item.heading
            ? 'u-textMuted'
            : 'u-textMedium u-textHeading u-textNormal'
        }
      >
        {item.heading && (
          <h5 className="u-mb--small u-textFluid--large">{item.heading}</h5>
        )}
        <div>
          <Data markdown>{item.blurb}</Data>
        </div>
      </ListItem>
    ))}
  </List>
);

GradientList.propTypes = {
  items: PropTypes.array.isRequired,
};

export default GradientList;
